export var DEFAULT_IS_REQUIRED_MESSAGE = 'This field is required';